import { Directive } from '@angular/core';

@Directive({
  selector: '[appNextGreenButton]',
  host: {
    'class': 'bg-green text-center text-white shadow-md hover:shadow-xl py-2 px-6 rounded-2xl font-light flex items-center justify-center gap-4 duration-300 cursor-pointer'
  },
  standalone: true
})
export class NextGreenButtonDirective {

  constructor() { }

}
